(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2415],{

/***/ 32782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ CollectionCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/styleguide/Card/Collection/collection-card.module.scss
var collection_card_module = __webpack_require__(74304);
var collection_card_module_default = /*#__PURE__*/__webpack_require__.n(collection_card_module);
;// CONCATENATED MODULE: ./components/styleguide/Card/Collection/CollectionCard.tsx




var CollectionCard = function(item) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: item.slug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: (collection_card_module_default()).container,
            "data-type": item.type,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (collection_card_module_default()).image,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (collection_card_module_default()).hover,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.imageAlt,
                                alt: item.name,
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (collection_card_module_default()).base,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.image,
                                alt: item.name,
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (collection_card_module_default()).mask
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (collection_card_module_default()).tag,
                            children: "Collection"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (collection_card_module_default()).label,
                            children: item.name
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Card/Collection/index.ts



/***/ }),

/***/ 72415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Collections; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
// EXTERNAL MODULE: ./components/styleguide/Card/Collection/index.ts + 1 modules
var Collection = __webpack_require__(32782);
// EXTERNAL MODULE: ./lib/inspiration-categories.js
var inspiration_categories = __webpack_require__(84098);
// EXTERNAL MODULE: ./components/styleguide/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(46118);
;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/Collections/Collections.tsx






var Collections = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Get started"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Most popular collections"
                })
            ]
        }),
        scrollValue: 797,
        moreLink: routes/* ROUTES.collectionsPage.url */.Z.collectionsPage.url,
        moreLabel: "lifestyle inspiration",
        sectionName: "collections",
        children: inspiration_categories/* HOMEPAGE.map */.ve.map(function(lifestyle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection/* CollectionCard */.z, (0,_object_spread/* default */.Z)({
                type: "carousel"
            }, lifestyle), lifestyle.id);
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/Collections/index.ts



/***/ }),

/***/ 84098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eW": function() { return /* binding */ LIFESTYLES; },
/* harmony export */   "od": function() { return /* binding */ COUNTRIES; },
/* harmony export */   "ve": function() { return /* binding */ HOMEPAGE; }
/* harmony export */ });
/* unused harmony export CATEGORY_COLORS */
var LIFESTYLES = [
    {
        id: 1,
        name: "Business professionals",
        image: "https://assets.leaseloco.com/inspiration/business/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/business/foreground.png",
        slug: "/car-leasing/business-professionals"
    },
    {
        id: 2,
        name: "Cheap car leasing",
        image: "https://assets.leaseloco.com/inspiration/cheap-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/cheap-car/foreground.png",
        slug: "/car-leasing/cheap-car-leasing"
    },
    {
        id: 3,
        name: "City cars",
        image: "https://assets.leaseloco.com/inspiration/city-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/city-car/foreground.png",
        slug: "/car-leasing/city-cars"
    },
    {
        id: 4,
        name: "Convertibles",
        image: "https://assets.leaseloco.com/inspiration/convertibles/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/convertibles/foreground.png",
        slug: "/car-leasing/convertible-car-leasing"
    },
    {
        id: 5,
        name: "Dog friendly",
        image: "https://assets.leaseloco.com/inspiration/dog-friendly/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/dog-friendly/foreground.png",
        slug: "/car-leasing/dog-friendly"
    },
    {
        id: 6,
        name: "Family cars",
        image: "https://assets.leaseloco.com/inspiration/family-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/family-car/foreground.png",
        slug: "/car-leasing/family-car-leasing"
    },
    {
        id: 7,
        name: "Fuel-efficient cars",
        image: "https://assets.leaseloco.com/inspiration/fuel-efficient/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/fuel-efficient/foreground.png",
        slug: "/car-leasing/fuel-efficient"
    },
    {
        id: 8,
        name: "High mileage deals",
        image: "https://assets.leaseloco.com/inspiration/high-mileage-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/high-mileage-car/foreground.png",
        slug: "/car-leasing/high-mileage-car-leasing"
    },
    {
        id: 9,
        name: "People carriers",
        image: "https://assets.leaseloco.com/inspiration/people-carriers/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/people-carriers/foreground.png",
        slug: "/car-leasing/mpv-car-leasing"
    },
    {
        id: 10,
        name: "Performance cars",
        image: "https://assets.leaseloco.com/inspiration/performance-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/performance-car/foreground.png",
        slug: "/car-leasing/performance-car-leasing"
    },
    {
        id: 11,
        name: "Pickup",
        image: "https://assets.leaseloco.com/inspiration/pick-ups/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/pick-ups/foreground.png",
        slug: "/van-leasing/pickup"
    },
    {
        id: 12,
        name: "Prestige",
        image: "https://assets.leaseloco.com/inspiration/prestige-cars/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/prestige-cars/foreground.png",
        slug: "/car-leasing/prestige-car-leasing"
    },
    {
        id: 13,
        name: "SUV",
        image: "https://assets.leaseloco.com/inspiration/suv/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/suv/foreground.png",
        slug: "/car-leasing/suv-car-leasing"
    },
    {
        id: 14,
        name: "Tradesmen",
        image: "https://assets.leaseloco.com/inspiration/traders/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/traders/foreground.png",
        slug: "/van-leasing/traders-van-leasing"
    }, 
];
var COUNTRIES = [
    {
        id: 0,
        name: "American",
        image: "https://assets.leaseloco.com/inspiration/american/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/american/foreground.png",
        slug: "/car-leasing/american-car-leasing"
    },
    {
        id: 1,
        name: "British",
        image: "https://assets.leaseloco.com/inspiration/british/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/british/foreground.png",
        slug: "/car-leasing/british-car-leasing"
    },
    {
        id: 2,
        name: "Chinese",
        image: "https://assets.leaseloco.com/inspiration/chinese/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/chinese/foreground.png",
        slug: "/car-leasing/chinese-car-leasing"
    },
    {
        id: 3,
        name: "French",
        image: "https://assets.leaseloco.com/inspiration/french/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/french/foreground.png",
        slug: "/car-leasing/french-car-leasing"
    },
    {
        id: 4,
        name: "German",
        image: "https://assets.leaseloco.com/inspiration/german/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/german/foreground.png",
        slug: "/car-leasing/german-car-leasing"
    },
    {
        id: 5,
        name: "Italian",
        image: "https://assets.leaseloco.com/inspiration/italian/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/italian/foreground.png",
        slug: "/car-leasing/italian-car-leasing"
    },
    {
        id: 6,
        name: "Japanese",
        image: "https://assets.leaseloco.com/inspiration/japanese/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/japanese/foreground.png",
        slug: "/car-leasing/japanese-car-leasing"
    },
    {
        id: 7,
        name: "Korean",
        image: "https://assets.leaseloco.com/inspiration/korean/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/korean/foreground.png",
        slug: "/car-leasing/korean-car-leasing"
    },
    {
        id: 8,
        name: "Spanish",
        image: "https://assets.leaseloco.com/inspiration/spanish/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/spanish/foreground.png",
        slug: "/car-leasing/spanish-car-leasing"
    },
    {
        id: 9,
        name: "Swedish",
        image: "https://assets.leaseloco.com/inspiration/swedish/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/swedish/foreground.png",
        slug: "/car-leasing/swedish-car-leasing"
    }, 
];
var HOMEPAGE = [
    {
        id: 1,
        name: "Family cars",
        image: "https://assets.leaseloco.com/inspiration/family-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/family-car/foreground.png",
        slug: "/car-leasing/family-car-leasing"
    },
    {
        id: 2,
        name: "Dog friendly",
        image: "https://assets.leaseloco.com/inspiration/dog-friendly/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/dog-friendly/foreground.png",
        slug: "/car-leasing/dog-friendly"
    },
    {
        id: 3,
        name: "Fuel-efficient cars",
        image: "https://assets.leaseloco.com/inspiration/fuel-efficient/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/fuel-efficient/foreground.png",
        slug: "/car-leasing/fuel-efficient"
    },
    {
        id: 4,
        name: "Cheap car leasing",
        image: "https://assets.leaseloco.com/inspiration/cheap-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/cheap-car/foreground.png",
        slug: "/car-leasing/cheap-car-leasing"
    },
    {
        id: 5,
        name: "City cars",
        image: "https://assets.leaseloco.com/inspiration/city-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/city-car/foreground.png",
        slug: "/car-leasing/city-cars"
    },
    {
        id: 6,
        name: "High mileage deals",
        image: "https://assets.leaseloco.com/inspiration/high-mileage-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/high-mileage-car/foreground.png",
        slug: "/car-leasing/high-mileage-car-leasing"
    },
    {
        id: 7,
        name: "German",
        image: "https://assets.leaseloco.com/inspiration/german/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/german/foreground.png",
        slug: "/car-leasing/german-car-leasing"
    },
    {
        id: 8,
        name: "SUV",
        image: "https://assets.leaseloco.com/inspiration/suv/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/suv/foreground.png",
        slug: "/car-leasing/suv-car-leasing"
    },
    {
        id: 9,
        name: "Business professionals",
        image: "https://assets.leaseloco.com/inspiration/business/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/business/foreground.png",
        slug: "/car-leasing/business-professionals"
    },
    {
        id: 10,
        name: "Performance cars",
        image: "https://assets.leaseloco.com/inspiration/performance-car/background.png",
        imageAlt: "https://assets.leaseloco.com/inspiration/performance-car/foreground.png",
        slug: "/car-leasing/performance-car-leasing"
    }, 
];
var CATEGORY_COLORS = (/* unused pure expression or super */ null && ([
    "orange",
    "pink",
    "blue",
    "black",
    "maroon",
    "purple",
    "green",
    "lilac", 
]));


/***/ }),

/***/ 74304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"collection-card_container__9wORO","base":"collection-card_base__zPt5i","hover":"collection-card_hover__UBlN3","image":"collection-card_image__dY7bS","label":"collection-card_label__LsFCk","tag":"collection-card_tag__Df4Z9","mask":"collection-card_mask__hgV3z","phAnimation":"collection-card_phAnimation__NFyJm"};

/***/ })

}]);